import {Component, NgZone, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {DateTime, Keyboard, NavController, NavParams, ViewController} from 'ionic-angular';
import {DomSanitizer} from "@angular/platform-browser";

import {CONFIG} from "../../../app/config";
import {TFieldType, TGoogleAnalytic, TModalClick, TStatusBar, Util} from "../../../app/util";
import {ImageScroll} from "../../../components/image-scroll/image-scroll";
import {
    ENUM,
    TAction,
    TAddDel,
    TBrandedTipo,
    TBlendedTipo,
    TProdutoTipo,
    TCarsale,
    TCertifyFlag,
    TImageModel,
    TImageSpace,
    TMeritumAuth,
    TFinanceSide,
    TPaybookTipo,
    TPaybookModo,
    TPaybookFato,
    TProfileFlag,
    TProfileSexo,
    TShareupTipo,
} from "../../../app/enum";
import {TFilterOpera} from "../../../pipes/filter-field/filter-field";
import {LogadoService} from "../../../providers/logado-service";
import {WebstorService} from "../../../providers/webstor-service";
import {ProfileMenuPage} from "../profile-menu/profile-menu";
import {ProfilePagePage} from "../profile-page/profile-page";
import {ProfileService} from "../../../providers/profile-service";
import {ProfileRepository} from "../../../repositories/profile-repository";
import {ListingMenuPage} from "../listing-menu/listing-menu";
import {ModalFieldPage} from "../modal-field/modal-field";
import {CarbookService} from "../../../providers/carbook-service";
import {PaybookCartPage} from "../paybook-cart/paybook-cart";
import {WebsiteSpotPage} from "../website-spot/website-spot";
import {getcard} from "../../../components/app-meritum/app-meritum";

@Component({
    selector: 'page-meritum-menu',
    templateUrl: 'meritum-menu.html',
    providers: [WebstorService, ProfileService, ProfileRepository]
})
export class MeritumMenuPage {

    @ViewChild(ImageScroll) iScroll: ImageScroll;
    @ViewChildren(DateTime) dateTime: QueryList<DateTime>;

    ENUM: any = ENUM;
    config: any;
    getcard: Function;

    TAction: any = TAction;
    TProfileFlag: any = TProfileFlag;
    TProfileSexo: any = TProfileSexo;
    TBrandedTipo: any = TBrandedTipo;
    TProdutoTipo: any = TProdutoTipo;
    TCertifyFlag: any = TCertifyFlag;
    TFilterOpera: any = TFilterOpera;

    TImageModel: any = TImageModel;
    TImageSpace: any = TImageSpace;

    shared: boolean;

    logado: any;
    rootile: any;

    homeb: boolean;
    etapa: number;
    etape: number;
    notifyes: any;
    meritums: any;
    copytums: any;

    userhot: any;
    allspot: boolean;
    textfind: string;
    errofind: string;

    indexHS: any;
    indexBL: number;
    indexBX: number;

    produtoTipo: TProdutoTipo;
    produtoType: string;
    blendedType: string;

    typelist: number;
    typequiz: number;

    backwork: any;

    yearnow: number;
    datebkp: string;

    searchTerm: string;

    constructor(public viewCtrl: ViewController, public navCtrl: NavController, public navParams: NavParams,
                public util: Util, public keyboard: Keyboard, private ngZone: NgZone,
                public logadoService: LogadoService, public carbookService: CarbookService,
                public webstorService: WebstorService,
                public profileService: ProfileService, public profileRepository: ProfileRepository,
                public sanitizer: DomSanitizer) {

        this.getcard = getcard;
        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.shared = this.navParams.get('shared');

        this.homeb = this.navParams.get('homeb');
        this.etapa = this.navParams.get('etapa');
        this.etape = this.navParams.get('etapa');
        this.rootile = this.navParams.get('rootile');

        this.meritums = this.navParams.get('meritums');
        this.copytums = this.navParams.get('copytums');

        this.userhot = this.navParams.get('userhot');
        this.allspot = this.navParams.get('allspot');
        this.textfind = this.navParams.get('textfind');
        this.notifyes = this.navParams.get('notifyes');

        this.indexHS = this.util.anyParams(0, this.navParams.get('indexHS'));
        this.indexBL = this.util.anyParams(0, this.navParams.get('indexBL'));
        this.indexBX = this.util.anyParams(0, this.navParams.get('indexBX'));

        this.produtoTipo = this.navParams.get('produtoTipo');
        this.produtoType = TProdutoTipo[this.produtoTipo];

        this.yearnow = (new Date).getFullYear();

        this.errofind = '';
        this.typelist = 0;
        this.typequiz = 0;
        if ((this.etapa == 0 || this.etapa == 1) && this.meritums[0].BlendedArray) {
            this.blendedType = this.meritums[0].BlendedArray[this.indexBL].BlendedID;
            if (!this.meritums[0][this.produtoType]) {
                this.meritums[0][this.produtoType] = [];
                this.meritums[0][this.produtoType]._CertifyFlag = TCertifyFlag.cfStatus;
            }
            if (!this.meritums[0][this.produtoType][this.blendedType]) {
                this.meritums[0][this.produtoType][this.blendedType] = {};
            }
        }

        if (!this.copytums) this.copytums = this.util.deepCopy(this.meritums);

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Marketing', '/hotspot-mark');

        let meritumID = this.util.anyParams(0, this.navParams.get('meritumID'));

        this.load(meritumID);

    }

    ionViewDidEnter() {

        //Color
        this.statusbar(false);

    }

    load(meritumID) {

        if (this.etapa == 0)  this.meritumRoot(null);
        if (this.etapa == 1)  this.meritumLoad(meritumID);
        if (this.etapa == 2)  this.meritumHtml();
        if (this.etapa == 3)  this.meritumHtml();
        if (this.etapa == 4)  this.meritumLoad(meritumID);
        if (this.etapa == 88) this.meritumCall();

    }

    backRender(event, varname) {

        this[varname] = event;

    }

    statusbar(header) {

        let color = (this.etapa == 0 || !this.copytums[0].Branded ? 'CorMenu' : (this.etapa == 1 ? 'CorMilk' : this.copytums[0].Branded.BrandedCora));
        if (header) return color;

        //Color
        let style = this.util.stylesBarColor(color);
        this.util.statusBarColor(style, false);

    }

    getTitle(): string {

        /* WEBS */ if (this.etapa == 0) return this.copytums[0].BlendedArray[this.indexBL].BlendedNome;
        /* PAGE */ if (this.etapa == 1) return this.copytums[0].Branded ? this.copytums[0].Branded.BrandedNome : this.copytums[0].MeritumNome;
        /* RULE */ if (this.etapa == 2) return 'Regulamento';
        /* CODE */ if (this.etapa == 3) return 'Código Esportivo';

        /* TWIN */ // (this.etapa == 4)
        /* FREE */ if (this.etapa == 5) return this.copytums[0].Profile.ProfileShow; //Certify-Free: Card Solicita Category Free
        /* SPOT */ if (this.etapa == 6) return this.copytums[0].Branded.BrandedNome; //Certify-Spot: Card Change Hotspot Linked
        /* MOVE */ if (this.etapa == 7) return this.copytums[0].Profile.ProfileShow; //Certify-Move: Card Change Category
        /* INFO */ // (this.etapa == 8)
        /* QUIZ */ if (this.etapa == 300) return this.copytums[0].MeritumNome;

        /* BLEN */ // (this.etapa == 15)
        /* BOXP */ // (this.etapa == 20)

        /* DOWN */ // (this.etapa == 50)
        /* LOGS */ // (this.etapa == 30)
        /* FIND */ // (this.etapa == 88)

        return '';

    }



    /** ************************************************* GENERIC ************************************************* **/
    /** *********************************************** etapa-X-Y-Z *********************************************** **/

    boolzito() {

        return (this.logado && this.logado.Profile.ProfileZito);

    }

    hotspotPage(branded) {

        let navActive = this.util.navActive(this.navCtrl);

        if (this.etapa == 4) {
            this.dismiss();

            //Navigate off - exemplo: acessei card do examinador do selo e click no card!
            if (this.navCtrl && this.navCtrl.getPrevious() && this.navCtrl.getPrevious().instance instanceof MeritumMenuPage && this.navCtrl.getPrevious().instance.etapa == 20) {
                return;
            }

            //Navigate off - exemplo: acessei HotspotPage THEWEEK abriu card e clicou no hotspot dentro do card (titulo da janela)
            let viewlast = navActive.getViews()[navActive.getViews().length-1];
            let samepage = (viewlast && viewlast.instance instanceof WebsiteSpotPage && viewlast.instance.rootdata.Hotspots[0].HotspotID == branded.HotspotID);
            if (samepage) this.util.toastSimply('Você já esta em ' + this.copytums[0].Branded.BrandedShow);

            //Navigate off - exemplo: acessei HotspotPage ABRA, depois a marca, abriu card e clicou no hotspot dentro do card (titulo da janela), acabou de fechar a modal agora da um pop() na marca vai retornar para o hotspot.
            let viewlest = navActive.getViews()[navActive.getViews().length-2];
            let samepege = (viewlest && viewlest.instance instanceof WebsiteSpotPage && viewlest.instance.rootdata.Hotspots[0].HotspotID == branded.HotspotID);
            if (samepege) viewlast.instance.dismiss();

            //Navigate off - não faz mais nada!
            if (samepage || samepege) return;

        }

        let object = {hotspotID: branded.HotspotID, brandex: branded, tabmenu: true};
        this.util.navActive(this.navCtrl).push(WebsiteSpotPage, object);

    }

    blendedSeal(): any[] {

        if (!this.copytums[0].BlendedArray) return [];

        //Para tirar ".Certify" pois está com os dados do perfil visitado!
        let array = this.util.deepCopy(this.copytums[0].BlendedArray);
        return array.filter(blended => !!blended.ProdutoSeals.length);

    }

    certifyHave(): boolean {

        let blendeds = this.copytums[0].BlendedArray;
        let haveCard = blendeds.filter(bl => bl.ProdutoCards.find(bx => !!bx.Certify)).length;
        let haveSeal = blendeds.filter(bl => bl.ProdutoSeals.find(bx => !!bx.Certify)).length;

        return (haveCard || haveSeal);

    }

    privacyShow(result: 'showsee' | 'checked'): boolean {

        let prienum = (result == 'checked' ? TAddDel.adNao : TAddDel.adDel);

        let blendeds = this.copytums[0].BlendedArray;

        let enumCard = blendeds.filter(bl => bl.ProdutoCards.find(bx => bx.Certify && bx.Certify.CertifyHide == prienum)).length;
        let enumSeal = blendeds.filter(bl => bl.ProdutoSeals.find(bx => bx.Certify && bx.Certify.CertifyHide == prienum)).length;

        let boolEnum = (enumCard || enumSeal);
        let boolHave = this.certifyHave();
        let boolUser = (this.logado && this.logado.Profile.ProfileID == this.copytums[0].Profile.ProfileID);

      //if (result == 'showsee') return ((havebool) && (this.boolzito() || boolUser));
        if (result == 'showsee') return ((boolHave) && (                   boolUser));
        if (result == 'checked') return ((boolHave) && (boolEnum));

    }







    /** ************************************************* MERITUM ************************************************* **/
    /** *********************************************************************************************************** **/

    clienteFind(rnid: string, ghosterID: number, meritumID: number) {

        this.profileRepository.profileFind(rnid, 'CPF', ProfileMenuPage, ghosterID)
            .subscribe(
                lino => {
                    this.textfind = rnid;
                    this.meritumLoad(meritumID);
                    //this.dismiss();
                });

    }

    meritumLoad(meritumID) {

        //meritumID = (meritumID || this.copytums[0].MeritumID);
        meritumID = this.copytums[0].MeritumID;

        if (this.copytums[0].Branded) return;

        let loading = this.util.loadingDots();
        if (this.etapa == 1) loading.present();

        let onClear = (message: string = '') => {
            this.errofind = message;
            this.textfind = '';
        };

        let qtd = (this.textfind + '').length;
        let cpf = isNaN(Number(this.textfind));
        if ((this.etapa != 1) && (!cpf && qtd != 8) && (cpf && qtd != 14)) return;

        if (this.etapa != 1 && cpf && !this.util.validaCNPF(this.textfind)) {
            onClear('Informe um CPF válido');
            return;
        }

        let action = (this.etapa == 1 ? TAction.acPage : TAction.acFind);
        let codigo = (this.etapa == 1 ? this.rootile.Profile.ProfileID : 0);

        this.webstorService.meritum(action, meritumID, 0, 0, codigo, this.textfind)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    if (!data.Meritums[0]) {
                        onClear('Meritum não encontrado!');
                        return;
                    }
                    if (!data.Meritums[0].Profile.ProfileID) {

                        //Find Meritum
                        let meritum = this.logado.Meritums.find(mr => mr.MeritumID == data.Meritums[0].MeritumID);
                        if (this.logado.Profile.ProfileZito || meritum.Usuario.UsuarioClev) {
                            this.clienteFind(this.textfind, data.Meritums[0].Branded.BrandedID, meritumID);
                            return;
                        }

                        onClear('Perfil não encontrado!');
                        return;
                    }
                    if (this.etapa != 1 && !data.Meritums[0].BlendedArray.filter(bl => !!bl.ProdutoCards.length).length) {
                        onClear('Nenhum cartão disponível!');
                        return;
                    }

                    this.util.populateObj(this.copytums, data.Meritums);
                    this.util.populateObj(this.meritums, data.Meritums);

                    let boolHave = this.certifyHave();

                    //Filiado e Franquia Randomize Unidades...
                    if (this.etapa == 1) {
                        if (data.Meritums[0].Branded.BrandedTipo == TBrandedTipo.btFiliado) this.util.arrayShuffle(data.Meritums[0].BrandedSpots);
                    }

                    //CertifyCard - Same Screen [windfind]
                    if (boolHave && this.etapa == 4) {
                        //Update Fundo do Backfull - Coloca como Async
                        if (this.backwork) setTimeout(() =>  this.backwork.backRender());
                    }

                    //CertifyCard - Same Screen [choice];
                    if (!boolHave && this.etapa == 4) {
                        let blended = this.copytums[0].BlendedArray.filter(bl => bl.BlendedTipo == TBlendedTipo.btCertify && bl.ProdutoCards.length)[0];
                        this.certifyEdit(TProdutoTipo.ptCard, blended, true);
                    }

                },
                erro => this.util.alertResult(erro, () => this.dismiss())
            )

    }

    meritumPage() {

        //Download
        if (!this.util.nativeApp() && this.shared) {
            this.etapa = 50;
            return;
        }

        this.dismiss();

        let navActive = this.util.navActive(this.navCtrl);

        //Navigate off - exemplo: acessei card do examinador do selo e click no card!
        if (this.navCtrl && this.navCtrl.getPrevious() && this.navCtrl.getPrevious().instance instanceof MeritumMenuPage && this.navCtrl.getPrevious().instance.etapa == 20) {
            return;
        }

        //Navigate off - exemplo: acessei marca abriu card e clicou na marca dentro do card
        let samepage = (navActive.getViews()[navActive.getViews().length-1].instance instanceof MeritumMenuPage);
        if (samepage) {
            this.util.toastSimply('Você já esta em ' + this.copytums[0].Branded.BrandedNome);
            return;
        }

        let meritums = this.meritums;
        let copytums = this.copytums;
        if (meritums[0].Profile.ProfileID != this.logado.Profile.ProfileID) {
            meritums = [{MeritumID: meritums[0].MeritumID}];
            copytums = null;
        }

        let blended = this.copytums[0].BlendedArray.filter(bl => bl.ProdutoCards.length)[0];
        let indexBL = this.copytums[0].BlendedArray.findIndex(bl => bl.BlendedID == blended.BlendedID);
        let object = {etapa: 1, rootile: this.logado, meritums: meritums, copytums: copytums, produtoTipo: this.produtoTipo, indexBL: indexBL};
        navActive.push(MeritumMenuPage, object);

    }

    //Meritum-User: Users list of meritum Card|Seal
    meritumUser(produto, sexo : TProfileSexo = TProfileSexo.psNenhum, usuario?) {

        let button = this.config.modalBotao('b-icon-list', 'Ordenar por...', ['Checkin', 'Valor']);

        let alignR = {};
        if (this.typelist == 0) alignR = {type: 'text', text: '', show: '',            toxt: '',    info: '', real: 'CertifyFleg',    color: 'CorInox'};
        if (this.typelist == 1) alignR = {type: 'text', text: '', show: 'ProdutoNome', toxt: '',    info: '', real: 'CertifyExpire',  color: 'CorInox'};
                            let alignL = {type: 'foto', text: '', show: ['Profile', 'ProfileFace'], info: '',                         color: ''};
                            let alignC = {type: 'text', text: '', show: ['Profile', 'ProfileShow'], info: ['Zipcity', 'ZipcityNome'], color: ''};

        let onShow = (show, that, limitPage, reload, eventMais) => {

            let blendedID = (!produto ? 0 : produto.BlendedID);
            let produtoID = (!produto ? 0 : produto.ProdutoID);
            let usuarioID = (!usuario ? 0 : usuario.ProfileID);
            let hotspotID = this.copytums[0].BrandedSpots[this.indexHS].HotspotID;

            let loading = this.util.loadingDots();
            loading.present();

            this.webstorService.certify(TAction.acList, this.copytums[0].MeritumID, blendedID, produtoID, 0, hotspotID, usuarioID, 0, TProdutoTipo.ptNone, sexo, this.meritums[0][this.produtoType]._CertifyFlag, '', limitPage)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => that.parseArray(data.Certifys, eventMais, data.LimitQtde, data.LimitPage),
                    erro => this.util.alertResult(erro, () => that.dismiss())
                );

        };

        let onOkuy = (okey, that, line, click, event) => {

            if (click == TModalClick.mcFoto) this.navCtrl.push(ProfilePagePage, {profileID: line.Profile.ProfileID});
            if (click != TModalClick.mcFoto) this.meritumOpen(null, {Profile: line});
            //if (click != TModalClick.mcMore) onShow();

        };

        let window = produto.ProdutoNome;
        let modalshow = this.config.listingForm(window, onShow, onOkuy, alignL, alignC, alignR, null, button);
        let objectData = {profile: this.logado.Profile, modalshow: modalshow, tabmenu: false};
        objectData.modalshow.header = '';
        objectData.modalshow.titulo = '';
        objectData.modalshow.resumo = '';
        objectData.modalshow.imagem = '';//(!produto ? usuario.ProfileFace : produto.ProdutoFoto);
        objectData.modalshow.radius = !produto;
        objectData.modalshow.molder = (!produto ? '1x1' : '2x3');

        this.navCtrl.push(ListingMenuPage, objectData);


    }

    meritumFind() {

        if (!this.util.validaCNPF(this.searchTerm)) return;

        let onClear = () => this.searchTerm = '';

        let meritem = {MeritumID: this.copytums[0].MeritumID};
        let object = {etapa: 4, rootile: this.rootile, meritums: [meritem], produtoTipo: TProdutoTipo.ptCard, copytums: null, textfind: this.searchTerm};
        this.util.modalopen(MeritumMenuPage, 'quad', true, object, null, null, null, onClear).subscribe();

    }

    meritumOpen(textfind?, rootile?) {

        if (!textfind) textfind = this.textfind;
        if (!rootile && !this.util.validaCNPF(textfind)) return;

        this.keyboard.close();
        this.keyboard.onClose(() => {

            if (rootile && !textfind) textfind = rootile.Profile.Profile.ProfileID;
            let onClear = () => this.textfind = '';

            let meritum = {MeritumID: this.copytums[0].MeritumID};
            let object = {etapa: 4, rootile: rootile, meritums: [meritum], produtoTipo: TProdutoTipo.ptCard, copytums: null, textfind: textfind};
            this.util.modalopen(MeritumMenuPage, 'quad', true, object, null, null, null, onClear).subscribe();

        });

    }

    meritumHtml(edit?) {

        //Já está carregado
        if (this.copytums[0].MeritumRule || this.copytums[0].MeritumCode) {
            if (edit) this.meritumEdit();
            return;
        }

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.meritum(TAction.acHtml, this.copytums[0].MeritumID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {
                    this.meritums[0].MeritumRule = data.Meritums[0].MeritumRule;
                    this.meritums[0].MeritumCode = data.Meritums[0].MeritumCode;
                    this.util.populateObj(this.copytums, this.meritums);

                    if (edit) this.meritumEdit();
                },
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    meritumRule() {

        let object = {etapa: 2, rootile: null, meritums: this.meritums, copytums: this.copytums};
        this.util.modalopen(MeritumMenuPage, 'quad', false, object).subscribe();

    }

    meritumCode() {

        let object = {etapa: 3, rootile: null, meritums: this.meritums, copytums: this.copytums};
        this.util.modalopen(MeritumMenuPage, 'quad', false, object).subscribe();

    }

    meritumTwin(check, press?): boolean {

        let result = (this.boolzito() || this.meritumAuth(TProdutoTipo.ptCard) || this.meritumAuth(TProdutoTipo.ptSeal));
        let insert = this.certifyCria(true, press);
        if (check) return (result || insert);

        let onProfile = () => {
            this.util.navActive().push(ProfilePagePage, {profileID: this.meritums[0].Profile.ProfileID});
            this.dismiss();
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Profile', handler: () => onProfile()});
        buttons.push({text: 'Compartilhar', handler: () => this.meritumLink()});
        if (result) buttons.push({text: 'Histórico', handler: () => this.meritumLogs()});
        if (insert) buttons.push({text: 'Certificar', handler: () => this.certifyCria(false, press)});
        if (insert) buttons.push({text: 'Filiação', handler: () => this.certifySpot()});
        this.util.sheetOpen(buttons, 'ACTION');

    }

    //Meritum-Link: Certify SHARELINK
    meritumLink() {

        let params = '&meritumid=' + this.meritums[0].MeritumID + '&profileid=' + this.meritums[0].Profile.ProfileID;
        this.profileRepository.sharedyLink(TShareupTipo.shMeritum, this.meritums[0].MeritumNome, 'meritum', params);

    }

    //Meritum-Logs: Twin Log of Meritum
    meritumLogs() {

        let onOpen = (notifyes) => {
            let object = {etapa: 30, rootile: null, meritums: this.meritums, copytums: this.copytums, produtoTipo: this.produtoTipo, notifyes: notifyes};
            this.util.modalopen(MeritumMenuPage, 'quad', true, object).subscribe();
        };

        let meritumID = this.copytums[0].MeritumID;

        let loading = this.util.loadingDots();
        loading.present();

        this.profileService.central(TAction.acLoad, '', this.copytums[0].Profile.ProfileID, meritumID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onOpen(data.Notifyes),
                erro => this.util.alertResult(erro)
            );

    }

    //Meritum-Auth: Card|Seal Change Category (check permitido alterar para level X) only disable class "ion-item-disabled"
    meritumAuth(produtoTipo: TProdutoTipo, rise?, blenfnd?): boolean {

        let usuarioName = (produtoTipo == TProdutoTipo.ptSeal ? 'UsuarioSeal' : 'UsuarioCard');
        let blendedID = (blenfnd ? blenfnd.BlendedID : this.copytums[0].BlendedArray[this.indexBL].BlendedID);

        //"Permissão" ou "Hierarquia" para alterar categoria
        if (this.copytums[0].MeritumAuth == TMeritumAuth.maUser) return this.copytums[0].Usuario[usuarioName];

        //Find Meritum
        let meritum = this.logado.Meritums.find(mr => mr.MeritumID == this.copytums[0].MeritumID);
        if (!meritum) return false;

        //Find Blended
        let blended = meritum.BlendedArray.find(blended => blended.BlendedID == blendedID);
        if (!blended) return false;

        //Find Produto
        let produto = blended.ProdutoSeals.find(bx => (bx.Certify && bx.Certify.CertifyFlag == TCertifyFlag.cfAprovado));
        if (!produto) return false;

        //Return if have itens to change
        let boxnamed = this.produtoNick(produtoTipo);
        if (!rise) return !!blended[boxnamed].filter(bx => bx.ProdutoRise <= produto.ProdutoLote).length;

        //Return if rise specific to change
        return (rise <= produto.ProdutoLote);

    }

    meritumEdit() {

        let editNome = this.homeb;
        let logado = this.logadoService.getAuth();

        let onOkiy = (that, okiy, index, isLast) => {

            if (this.util.slideNext(that, !isLast)) return;

            if (!this.copytums[0].MeritumID) {
                this.copytums[0].MeritumNome = '';
                this.copytums[0].MeritumInfo = '';
                this.copytums[0].MeritumRuli = false;
                this.copytums[0].MeritumRule = '';
                this.copytums[0].MeritumCodi = false;
                this.copytums[0].MeritumCode = '';
            }

            let dec = (editNome ? 0 : 1);
            this.copytums[0].MeritumNome = (!editNome ? this.copytums[0].MeritumNome : okiy[0].groups[0].fields[0].value);
            this.copytums[0].MeritumInfo = okiy[1-dec].groups[0].fields[0].value;
            this.copytums[0].MeritumRuli = okiy[2-dec].groups[0].fields[0].value.length > 0;
            this.copytums[0].MeritumRule = okiy[2-dec].groups[0].fields[0].value;
            this.copytums[0].MeritumCodi = (!okiy[3-dec] ? '' : okiy[3-dec].groups[0].fields[0].value).length > 0;
            this.copytums[0].MeritumCode = (!okiy[3-dec] ? '' : okiy[3-dec].groups[0].fields[0].value);

            let loading = this.util.loadingDots();
            loading.present();

            this.webstorService.meritum(TAction.acSave, this.copytums[0].MeritumID, this.copytums[0].Branded.HotspotID, logado.Profile.ProfileID, this.copytums[0])
                .finally(() => loading.dismiss())
                .subscribe(
                    data => {

                        if (that) that.dismiss();

                    },
                    erro => this.util.alertResult(erro)
                );

        };

        /** SLIDE 01 **/
        let fieldName = this.config.modalField(TFieldType.ftLine, null, null, null, this.copytums[0].MeritumNome, null, null);
        let groupName = this.config.modalGroup('Nome do Meritum', [fieldName]);
        let slideName = this.config.modalSlide('Meritum', null, 'Card e Seal.', 'b-icon-bookmark-empty', 'CorRoxa', [groupName]);

        /** SLIDE 02 **/
        let fieldGain = this.config.modalField(TFieldType.ftHtml, null, null, null, this.copytums[0].MeritumInfo, null, null);
        let groupGain = this.config.modalGroup(null, [fieldGain]);
        let slideGain = this.config.modalSlide('Benefícios', null, null, null, 'CorRoxa', [groupGain]);

        /** SLIDE 03 **/
        let fieldRule = this.config.modalField(TFieldType.ftHtml, null, null, null, this.copytums[0].MeritumRule, null, null);
        let groupRule = this.config.modalGroup(null, [fieldRule]);
        let slideRule = this.config.modalSlide('Regulamento', null, null, null, 'CorRoxa', [groupRule]);

        /** SLIDE 04 **/
        let fieldCode = this.config.modalField(TFieldType.ftHtml, null, null, null, this.copytums[0].MeritumCode, null, null);
        let groupCode = this.config.modalGroup(null, [fieldCode]);
        let slideCode = this.config.modalSlide('Código Esportivo', null, null, null, 'CorRoxa', [groupCode]);

        let slides = [];
        if (this.copytums[0].MeritumAuth == TMeritumAuth.maUser) slides = [slideRule];
        if (this.copytums[0].MeritumAuth == TMeritumAuth.maRise) slides = [slideGain, slideRule, slideCode];
        if (editNome) slides.splice(0, 0, slideName);

        this.util.modalopen(ModalFieldPage, 'quad', false, {slides: slides, onOkiy: onOkiy}).subscribe();

    }

    meritumRoot(event, reload?) {

        if (this.typelist == 0 && this.copytums[0][this.produtoType][this.blendedType].BlendedSexos && !event && !reload) return;
        if (this.typelist == 1 && this.copytums[0][this.produtoType][this.blendedType].BlendedUsers && !event && !reload) return;
        if (this.typelist == 2 && this.copytums[0][this.produtoType][this.blendedType].BrandedSpots && !event && !reload) return;

        let loading = this.util.loadingDots();
        if (!event) loading.present();

        let action = TAction.acSexo;
        let hotspotID = (this.allspot ? this.copytums[0].Branded.HotspotID : this.copytums[0].BrandedSpots[this.indexHS].HotspotID);
        if (this.typelist == 0) action = (this.allspot ? TAction.acSexo : TAction.acSexe);
        if (this.typelist == 1) action = TAction.acUser;
        if (this.typelist == 2) action = TAction.acSpot;

        this.webstorService.certify(action, this.copytums[0].MeritumID, this.copytums[0].BlendedArray[this.indexBL].BlendedID, 0, 0, hotspotID, 0, this.rootile.Profile.ProfileID, this.produtoTipo, TProfileSexo.psNenhum, this.meritums[0][this.produtoType]._CertifyFlag)
            .finally(() => {
                if (event) event.complete();
                loading.dismiss();
            })
            .subscribe(
                data => {

                    //Sexo
                    if (this.typelist == 0) {
                        this.meritums[0][this.produtoType][this.blendedType].Qtdecalc = data.Qtdecalc;
                        this.meritums[0][this.produtoType][this.blendedType].BlendedSexos = data.Certifys;
                        this.copytums = this.util.deepCopy(this.meritums);
                    }

                    //Team
                    if (this.typelist == 1) {
                        this.meritums[0][this.produtoType][this.blendedType].BlendedUsers = data.Certifys;
                        this.copytums[0][this.produtoType][this.blendedType].BlendedUsers = [];
                        this.util.populateObj(this.copytums, this.meritums);
                    }

                    //Spot
                    if (this.typelist == 2) {
                        this.meritums[0][this.produtoType][this.blendedType].BrandedSpots = data.Certifys;
                        this.copytums[0][this.produtoType][this.blendedType].BrandedSpots = [];
                        this.util.populateObj(this.copytums, this.meritums);
                    }

                },
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    //Meritum-Spot: Abre filtrando o spot quando está webstor (meritumRoot)
    meritumSpot(index) {

        let meritum = {MeritumID: this.copytums[0].MeritumID, MeritumNome: this.copytums[0].MeritumNome, MeritumFind: this.copytums[0].MeritumFind, Branded: this.copytums[0].Branded, BrandedSpots: this.copytums[0][this.produtoType][this.blendedType].BrandedSpots, BlendedArray: this.copytums[0].BlendedArray};
        let object = {etapa: 0, rootile: this.rootile, userhot: this.userhot, meritums: [meritum], copytums: [meritum], indexHS: index, produtoTipo: this.produtoTipo, indexBL: this.indexBL};
        this.navCtrl.push(MeritumMenuPage, object);

    }

    //Meritum-File: Gera arquivo para download user x certify
    meritumFile(produto, open?) {

        if (open) {
            this.util.open(produto.Memberfile, '_blank');
            produto.Memberfile = '';
            return;
        }

        let hotspotID = this.copytums[0].BrandedSpots[this.indexHS].HotspotID;

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.certify(TAction.acFile, this.copytums[0].MeritumID, produto.BlendedID, produto.ProdutoID, 0, hotspotID, 0, 0, TProdutoTipo.ptNone, TProfileSexo.psNenhum, this.meritums[0][this.produtoType]._CertifyFlag)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {
                    produto.Memberfile = data.Filename;
                    this.util.populateObj(this.meritums, this.copytums);
                    this.util.open(data.Filename, '_blank');
                },
                erro => this.util.alertResult(erro)
            );

    }

    //Meritum-Find: Open, Free, Sale
    meritumCall() {

        let boxHave = this.getcard(this.copytums[0]);
        let boxNovo = this.getcard(this.copytums[0], true);//#AKI

        //Open
        if (boxNovo && boxNovo.Certify && this.etapa != 4 && (!boxNovo.RenovarCash || boxHave || this.etapa == 1)) {
            if (this.etapa == 88) {
                this.etapa = 4;
                this.etape = 4;
                this.produtoTipo = TProdutoTipo.ptCard;
                return;
            }
            let object = {etapa: 4, rootile: null, meritums: this.meritums, produtoTipo: TProdutoTipo.ptCard, copytums: this.copytums};
            this.util.modalopen(MeritumMenuPage, 'quad', true, object).subscribe();
            return;
        }

        //Free
        if (boxNovo && !boxNovo.Certify && !boxNovo.RenovarCash) {
            if (this.etapa == 88) {
                this.etapa = 5;
                this.etape = 5;
                this.produtoTipo = TProdutoTipo.ptCard;
                return;
            }
            let object = {etapa: 5, rootile: null, meritums: this.meritums, copytums: this.copytums};
            this.util.modalopen(MeritumMenuPage, 'quad', true, object).subscribe();
            return;
        }

        //Sale
        if (boxNovo && boxNovo.RenovarCash) {
            if (this.etapa == 88) {
                this.etapa = 6;
                this.etape = 6;
                this.produtoTipo = TProdutoTipo.ptCard;
                return;
            }

            //Oute
            if (this.copytums[0].Profile.ProfileFlag != TProfileFlag.pfActive) {
                this.util.toastSimply('Perfil não está ativo.');
                return;
            }

            //CONDIÇÃO: "this.viewCtrl.isOverlay" => "(this.etapa == 4 || this.etapa == 88)"
            if (this.viewCtrl.isOverlay) this.dismiss();


            /** CARRINHO SET|OPEN **/
            let meritum = this.util.deepCopy(this.copytums[0]);
            let boxfind = this.getcard(meritum, true, true);//#AKI-Cria
            this.carbookService.setStart(TCarsale.csMerito, meritum);



            let paycria = {
                HotspotID: this.copytums[0].HotspotID,
                ContratID: 0,
                Branded: this.util.deepCopy(this.copytums[0].Branded),
                Promote: null,
                Projeto: {ProjetoID: 1000, ProjetoNome: 'Fake'},
                Profile: this.util.deepCopy(this.copytums[0].Profile),

                PaybookID: 0,
                PaybookSide: TFinanceSide.cdCredito,
                PaybookFato: TPaybookFato.ctVencer,
                PaybookTipo: TPaybookTipo.pbCard,
                PaybookModo: TPaybookModo.pmUser,
                PaybookNoro: 0,
                PaybookHide: false,
                PaybookParc: 0,
                PaybookBase: this.util.dateToStr(null, false),
                PaybookCria: this.util.dateToStr(null, true),
                PaybookBora: '',
                PaybookText: '',

                Consumos: [],
                Parcelas: [],
                Invoices: [],
            };
            this.carbookService.paybookPush(paycria);



            boxfind.Certify.CertifySpot = this.copytums[0].BrandedSpots[this.indexHS];
            boxfind.Certify.CertifyFlag = TCertifyFlag.cfAprovado;
            boxfind.Certify.CertifyStop = boxfind.ProdutoStop;


            /** CERTIFY DEFINE **/
            /*
            let boxfond = this.getcard(this.meritums[0], true);
            boxfond.Renovar._certify = {
                MeritumID: meritum.MeritumID,
                ProdutoID: boxfind.ProdutoID,
                ProfileID: meritum.Profile.ProfileID,
                HotspotID: boxfind.Certify.CertifySpot.HotspotID,
                CertifyID: boxfind.Certify.CertifyID,
                CertifyFlag: boxfind.Certify.CertifyFlag,
                CertifyStop: boxfind.Certify.CertifyStop,
            };
            */

            let consume = {Profile: null, Branded: null, Blended: null, Produto: null, Consumo: null};
            consume.Profile = this.util.deepCopy(meritum.Profile);
            consume.Branded = this.util.deepCopy(meritum.Branded);
            consume.Blended = this.copytums[0].BlendedArray.filter(bl => bl.ProdutoCards.length)[0];
            consume.Produto = this.util.deepCopy(boxfind);
            consume.Consumo = {ConsumoQtde: 1, ConsumoCash: boxfind.RenovarCash, ConsumoLess: 0};
            console.log(boxfind);


            let object = {etapa: 1, consumo: consume};
            this.util.navActive(this.navCtrl).push(PaybookCartPage, object, {direction: 'forward'});
            //ESTA NA MODAL, Então... Pega active nav para dar o push!

        }

    }

    blendedTwin(produtoTipo: TProdutoTipo, blended) {

        let indexBL = this.copytums[0].BlendedArray.findIndex(bl => bl.BlendedID == blended.BlendedID);
        let object = {etapa: 15, rootile: this.rootile, meritums: this.meritums, copytums: this.copytums, produtoTipo: produtoTipo, indexBL: indexBL};
        this.util.modalopen(MeritumMenuPage, 'quad', true, object).subscribe();

    }

    //Produto-Twin: Info of produto Card|Seal
    produtoTwin(produto) {

        if (!this.logado) {
            this.util.alertSimply('Efetue o login');
            return;
        }

        let boxnamed = this.produtoNick();
        let indexBX = this.copytums[0].BlendedArray[this.indexBL][boxnamed].indexOf(produto);

        let onOpenig = () => {
            let object = {etapa: 20, rootile: this.rootile, meritums: this.meritums, copytums: this.copytums, produtoTipo: this.produtoTipo, indexBL: this.indexBL, indexBX: indexBX};
            this.util.modalopen(MeritumMenuPage, 'quad', true, object).subscribe();
        };

        if (produto.Patentes) {
            onOpenig();
            return;
        }

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.certify(TAction.acSeal, this.copytums[0].MeritumID, 0, produto.ProdutoID, 0, 0, 0, 0, this.produtoTipo)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {
                    produto.Patentes = data.Certifys;
                    this.meritums[0].BlendedArray[this.indexBL][boxnamed][indexBX].Patentes = data.Certifys;
                    this.copytums[0].BlendedArray[this.indexBL][boxnamed][indexBX].Patentes = data.Certifys;
                    onOpenig();
                },
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }







    /** ************************************************* CERTIFY ************************************************* **/
    /** *********************************************** etapa-X-Y-Z *********************************************** **/

    //Certify-Exec: Twin Click in Blended
    certifyExec(produtoTipo: TProdutoTipo, blended) {

        if (!blended && produtoTipo == TProdutoTipo.ptCard) {
            blended = this.copytums[0].BlendedArray.filter(bl => bl.BlendedTipo == TBlendedTipo.btCertify && bl.ProdutoCards.length)[0];
        }

        let usclev = this.copytums[0].Usuario.UsuarioClev;
        let editar = (usclev || this.meritumAuth(produtoTipo, 0, blended));

        //Card Click Open Meritum-Page
        if (produtoTipo == TProdutoTipo.ptCard && !editar) {
            this.meritumPage();
            return;
        }

        //Start Variables
        let exclui = this.boolzito();
        let validy = (this.boolzito() || usclev || (editar && this.copytums[0].MeritumAuth == TMeritumAuth.maUser));
        let alerta = (produtoTipo == TProdutoTipo.ptCard ? 'Deseja excluir CARD?' : 'Deseja excluir SEAL?');

        //OnDate
        let onDate = () => {

            //Card fica no "0" proximo lista dos selos...
            let boxnamed = this.produtoNick(produtoTipo);
            let index = this.copytums[0].BlendedArray.findIndex(bl => bl.BlendedID == blended.BlendedID);
            let produto = this.copytums[0].BlendedArray[index][boxnamed].find(bx => !!bx.Certify);

            //Card fica no "0" proximo lista dos selos...
            index = ((index + 1) * 2) -2;
            if (produtoTipo == TProdutoTipo.ptCard) index = index + 0;
            if (produtoTipo == TProdutoTipo.ptSeal) index = index + 1;

            this.datebkp = produto.Certify.CertifyStop;
            this.dateTime.toArray()[index].open();
        };

        //OnInfo
        let onInfo = () => {
            //Certify-Info: Twin Open Window Detail
            let indexBL = this.copytums[0].BlendedArray.indexOf(blended);
            let object = {etapa: 8, rootile: this.rootile, meritums: this.meritums, copytums: this.copytums, produtoTipo: produtoTipo, indexBL: indexBL};

            this.util.modalopen(MeritumMenuPage, 'quad', true, object).subscribe(data => {
                if (this.iScroll && data && data.updated) this.iScroll.update();
            });
        };

        //OnLixo
        let onLixo = () => {
            this.certifySave(TAction.acLixo, alerta, true, null, produtoTipo, blended);
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Status', handler: () => onInfo()});
        if (editar) buttons.push({text: 'Categoria', handler: () => this.certifyEdit(produtoTipo, blended)});
        if (validy) buttons.push({text: 'Validade',  handler: () => onDate()});
        if (exclui) buttons.push({text: 'Excluir',   handler: () => onLixo(), role: 'destructive'});
        this.util.sheetOpen(buttons, 'ACTION');

    }

    filterseal(have): any[] {

        let blendeds = this.copytums[0].BlendedArray;
        if (have)  return blendeds.filter(bl => bl.ProdutoSeals.find(bx => (bx.Certify && bx.Certify.CertifyFlag == TCertifyFlag.cfAprovado)));
        if (!have) return blendeds.filter(bl => bl.ProdutoSeals.find(bx => (bx.Certify && bx.Certify.CertifyFlag != TCertifyFlag.cfAprovado)));

    }

    //Certify-Free: Card Solicita Category Free
    certifyFree() {

        if (this.etapa == 5) {
            let produto = this.getcard(this.copytums[0], true, true);//#AKI-Cria

            if (this.copytums[0].BrandedSpots.length == 1) {
                produto.Certify.CertifySpot = this.copytums[0].BrandedSpots[0];
                this.certifySave(TAction.acSave);
                return;
            }

            this.etapa = 6;
            this.produtoTipo = TProdutoTipo.ptCard;
            this.statusbar(false);
        }

    }

    //Certify-Cria: Seal Insert With Category
    certifyCria(check?, force?): boolean {

        let array = this.copytums[0].BlendedArray.filter(bl => {
            let auth = (force || !!this.meritumAuth(TProdutoTipo.ptSeal, 0, bl));
            let have = bl.ProdutoSeals.find(bx => bx.Certify);
            return (auth && !have);
        });
        if (!array.length || check) return !!array.length;


        //Execute
        let onSave = (blended) => {
            this.certifyEdit(TProdutoTipo.ptSeal, blended, true);
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        array.forEach(BL => buttons.push({text: BL.BlendedNome, handler: () => onSave(BL)}));
        buttons.push({text: 'Cancelar', role: 'destructive'});
        this.util.sheetOpen(buttons, 'SEAL');

    }

    //Certify-Edit: Twin Open to change Category
    certifyEdit(produtoTipo: TProdutoTipo, blended, close: boolean = false) {

        let onClose = () => {

            if (close && this.etapa != 4) this.navCtrl.getPrevious().dismiss();
            if (!close) {
                this.etapa = 4;
                this.etape = 4;
                this.produtoTipo = TProdutoTipo.ptCard;
            }

        };

        let onData = () => {
            let boxnamed = this.produtoNick(produtoTipo);
            let produto = blended[boxnamed].find(bx => !!bx.Certify);
            if (!produto || !close || !newnew) {
                let boolHave = this.certifyHave();
                if (!boolHave) this.dismiss(false, true);
                return;
            }

            let toaste = this.util.nomeFirst(this.copytums[0].Profile.ProfileShow) + ' agora é ' + this.copytums[0].MeritumNome + ' ' + blended.BlendedNome + ' ' + produto.ProdutoNome;
            this.util.toastSimply(toaste);
        };

        let newnew = !this.produtoPega(produtoTipo, blended);

        let index = this.copytums[0].BlendedArray.indexOf(blended);
        let object = {etapa: 7, rootile: null, meritums: this.meritums, copytums: this.copytums, produtoTipo: produtoTipo, indexBL: index};
        this.util.modalopen(MeritumMenuPage, 'quad', false, object, null, null, null, onClose).subscribe(data => onData());

    }

    //Certify-Move: Twin Change Category
    certifyMove(index?) {

        if (this.etapa == 7) {

            this.util.impact();
            
            //Trava pega valor antes da alteracao
            let boxnamed = this.produtoNick();
            let boxHave = this.copytums[0].BlendedArray[this.indexBL][boxnamed].find(bx => !!bx.Certify);
            let boxNovo = this.copytums[0].BlendedArray[this.indexBL][boxnamed][index];

            let certify = (boxHave ? boxHave.Certify : null);
            if (!certify) {
                //[privacy]
                let boxfind = this.getcard(this.copytums[0]);
                let boxhide = TAddDel.adNao;
                if (boxfind) boxhide = boxfind.Certify.CertifyHide;

                //[status/expira]
                let status = (boxNovo.RenovarCash ? TCertifyFlag.cfExpirado : TCertifyFlag.cfAprovado);
                let expira = (boxNovo.RenovarCash ? ''                      : boxNovo.ProdutoStop);
                let usuario = {UsuarioID: this.logado.Profile.ProfileID, UsuarioShow: this.logado.Profile.ProfileShow, UsuarioFace: this.logado.Profile.ProfileFace};

                certify = {CertifyID: 0, CertifySpot: null, CertifyFlag: status, CertifyStop: expira, CertifyHide: boxhide, Usuario: usuario};
                certify.CertifySpot = this.copytums[0].BrandedSpots[0];
            }

            //Remove certificado antigo
            this.copytums[0].BlendedArray[this.indexBL][boxnamed].forEach(flag => flag.Certify = null);

            //Define certificado novo
            boxNovo.Certify = certify;
            boxNovo.RenovarCash = 0;

            //Trava para nao alterar se meritum tem categoria maior que eu posso alterar
            if (!this.meritumAuth(this.produtoTipo, boxNovo.ProdutoRise)) {
                setTimeout(() => this.util.populateObj(this.copytums[0], this.meritums[0], [], true), 500);
                this.util.alertSimply('Categoria atual superior ao permitido.');
                return;
            }

            //Confirmação para alterar a categoria
            if (!certify.CertifySpot) this.etapa = 6;
            if (certify.CertifySpot) {
                let nome = this.util.nomeFirst(this.copytums[0].Profile.ProfileShow);
                let name = this.copytums[0].BlendedArray[this.indexBL].BlendedNome + ' ' + boxNovo.ProdutoNome;
                let alerta = name + '<br>Certificar <b>' + nome + '</b>?';
                this.certifySave(TAction.acSave, alerta);
            }

            this.statusbar(false);
        }

    }

    //Certify-Spot: Card Change Hotspot Linked
    certifySpot(index?) {

        //Filiacao Ask
        if (this.etapa == 4) {
            if (this.getcard(this.copytums[0]).Certify.CertifyFlag != TCertifyFlag.cfAprovado) {
                this.util.toastSimply('Precisa estar ativo para alterar.');
                return;
            }

            let blended = this.copytums[0].BlendedArray.filter(bl => bl.ProdutoCards.length)[0];
            let indexBL = this.copytums[0].BlendedArray.findIndex(bl => bl.BlendedID == blended.BlendedID);

            let object = {etapa: 6, rootile: null, meritums: this.meritums, copytums: this.copytums, produtoTipo: TProdutoTipo.ptCard, indexBL: indexBL};
            this.util.modalopen(MeritumMenuPage, 'quad', true, object).subscribe();
            return;
        }

        //Filiacao Set
        if (this.etapa == 6 && this.getcard(this.copytums[0])) {
            let action = (this.etapa == this.etape ? TAction.acEdit : TAction.acSave);
            let boxfind = this.getcard(this.copytums[0]);
            boxfind.Certify.CertifySpot = this.copytums[0].BrandedSpots[index];
            this.certifySave(action);
            return;
        }

        //Sale
        if (this.etapa == 6 && !this.getcard(this.copytums[0])) {
            this.meritumCall();
            return;
        }

    }

    //Certify-Days: Card Days calculed to expire (progressbar)
    certifyDays(): number {

        let boxfind = this.getcard(this.copytums[0]);
        let dias = new Date(boxfind.Certify.CertifyStop).getDate() + 1;
        let hoje = (new Date().getDate());
        return (hoje * 100) / dias;

    }

    //Certify-Date: Twin Change Expira
    certifyDate(produtoTipo: TProdutoTipo, blended, clear?) {

        //DateChange
        let produto = this.produtoPega(produtoTipo, blended);
        if (!produto) return;

        if (clear) {
            if (produto.Certify.CertifyFlag == TCertifyFlag.cfExpirado) produto.Certify.CertifyFlag = TCertifyFlag.cfAprovado;
            produto.Certify.CertifyStop = '';
            this.certifySave(TAction.acDate, null, false, null, produtoTipo, blended);
            return;
        }

        let datebkp;
        if (produto && produto.Certify) datebkp = produto.Certify.CertifyStop;

        if (this.datebkp == datebkp) return;
        this.datebkp = datebkp;

        if (produto.Certify.CertifyStop) {
            let data = produto.Certify.CertifyStop.slice(0, 7) + '-1';
            let date = this.util.diaLast(new Date(data));
            let hoje = this.util.dateHoje();

            //#Inverte Aprovado vs Expirado vs Aprovado
            if (produto.Certify.CertifyFlag == TCertifyFlag.cfExpirado || produto.Certify.CertifyFlag == TCertifyFlag.cfAprovado) {
                let rule = (date>hoje ? TCertifyFlag.cfAprovado : TCertifyFlag.cfExpirado);
                produto.Certify.CertifyFlag = rule;
            }

            produto.Certify.CertifyStop = this.util.dateToStr(date);
        }

        this.certifySave(TAction.acDate, null, false, null, produtoTipo, blended);

    }

    //Certify-Quiz: Twin Answer Quiz
    certifyQuiz() {

        if (this.etapa == 8) {
            let onClose = () => this.navCtrl.getPrevious().dismiss();
            let object = {etapa: 300, rootile: null, meritums: this.meritums, copytums: this.copytums, produtoTipo: this.produtoTipo, indexBL: this.indexBL};
            this.util.modalopen(MeritumMenuPage, 'quad', false, object, null, null, null, onClose).subscribe();
        }

        if (this.typequiz == 0) {
            this.typequiz = 9;
        }

    }

    //Certify-Filt: Twin Filter Certify por Status "etapa: 0"
    certifyFilt() {

        let onSave = (cert) => {
            this.meritums[0][this.produtoType]._CertifyFlag = cert;
            this.meritumRoot(null, true);
        };

        /** OPEN **/
        let arrayEnum = this.util.enumArray(TCertifyFlag);
        let buttons: Array<any> = [];
        arrayEnum.forEach(cert => buttons.push({text: cert.slice(2, 99), handler: () => onSave(TCertifyFlag[cert])}));
        this.util.sheetOpen(buttons, 'FILTER');

    }

    //Certify-Turn: Twin "Vira" o status (troca)
    certifyTurn(status: TCertifyFlag) {

        let produto = this.produtoPega();
        let success = '';

        if (status == TCertifyFlag.cfInscrito) success = 'Você está inscrito no selo <b>' + produto.ProdutoNome + '</b>.';

        //Quando patente está aprovando/revogando selo inscrito
        let bool = (produto && produto.Certify.CertifyFlag == TCertifyFlag.cfInscrito && produto.ProdutoTipo == TProdutoTipo.ptSeal);
        if (bool && status == TCertifyFlag.cfAprovado) produto.Certify.CertifyStop = produto.ProdutoStop;
      //if (bool && status == TCertifyFlag.cfRevogado) produto.Certify.CertifyStop = '';

        //Quando está aprovando define Privacy de Card|Seal para none
        if (produto) produto.Certify.CertifyFlag = status;
        let array = this.copytums[0].BlendedArray[this.indexBL].ProdutoSeals.filter(cf => !!cf.Certify);
        if (status == TCertifyFlag.cfAprovado) {
            produto.Certify.CertifyHide = TAddDel.adNao;
            array.forEach(seal => seal.Certify.CertifyHide = TAddDel.adNao);
        }

        let profind = this.getcard(this.meritums[0]);
        let mylest = (profind && [TCertifyFlag.cfAprovado, TCertifyFlag.cfExpirado].indexOf(profind.Certify.CertifyFlag) >= 0);
        let mylost = (mylest && this.etapa == 4 && this.logado.Profile.ProfileID == this.copytums[0].Profile.ProfileID && status == TCertifyFlag.cfRevogado);
        if (!mylost) this.certifySave(TAction.acSave, 'Deseja alterar o status?', true);
        if (mylost)  this.certifySave(TAction.acLost, 'Deseja excluir?<br>Esse processo não tem volta.', true, success);

    }

    //Certify-Twin: acSave, acEdit, acDate, acHide, acLost, acLixo
    certifySave(action: TAction, alerta: string = null, danger: boolean = false, success: string = null, produtoTipo: TProdutoTipo = TProdutoTipo.ptNone, blended: any = null) {

        //Privacy
        if (action == TAction.acHide) {

            this.util.impact();

            let blendCards = this.copytums[0].BlendedArray.filter(bl => bl.ProdutoCards.find(bx => !!bx.Certify));
            let blendSeals = this.copytums[0].BlendedArray.filter(bl => bl.ProdutoSeals.find(bx => !!bx.Certify));

            //CARD - Lock/Unlock
            blendCards.forEach(BL => {
                let produto = BL.ProdutoCards.find(PD => !!PD.Certify);
                produto.Certify.CertifyHide = !produto.Certify.CertifyHide;
            });

            //SEAL - Lock/Unlock
            blendSeals.forEach(BL => {
                let produto = BL.ProdutoSeals.find(PD => !!PD.Certify);
                produto.Certify.CertifyHide = !produto.Certify.CertifyHide;
            });

        }


        //Execute
        let onCancel = () => this.util.populateObj(this.copytums[0], this.meritums[0], [], true);
        let onConfir = () => {

            let meritum = this.copytums[0];
            blended = (blended ? blended : meritum.BlendedArray[this.indexBL]);

            let boxnamed = this.produtoNick(produtoTipo);
            let produto = blended[boxnamed].find(bx => !!bx.Certify);
            console.log(produto);
            let hotsoptID = (!produto ? 0 : (!produto.Certify || !produto.Certify.CertifySpot ? produto.HotspotID : produto.Certify.CertifySpot.HotspotID));
            let certifyID = (!produto ? 0 : produto.Certify.CertifyID);
            let produtoID = (!produto ? 0 : produto.ProdutoID);
            let protipo = (!produto ? produtoTipo : produto.ProdutoTipo);
            let cexpira = (!produto ? 0 : produto.Certify.CertifyStop);
            let cstatus = (!produto ? TCertifyFlag.cfStatus : produto.Certify.CertifyFlag);

            let loading = this.util.loadingDots();
            loading.present();

            this.webstorService.certify(action, meritum.MeritumID, blended.BlendedID, produtoID, certifyID, hotsoptID, 0, meritum.Profile.ProfileID, protipo, TProfileSexo.psNenhum, cstatus, cexpira)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => {

                        if (produto && !produto.Certify.CertifyID) produto.Certify.CertifyID = data.Codigo;

                        //Card Delete
                        if (action == TAction.acLixo || action == TAction.acLost) produto.Certify = null;

                        this.util.populateObj(this.meritums, this.copytums, [], true);
                        this.logadoService.meritumPush(this.meritums[0]);

                        //ImageScroll Update
                        setTimeout(() => {
                            if (this.iScroll) this.iScroll.update();
                        });

                        let boolHave = this.certifyHave();
                        let deleted = (action == TAction.acLost || (action == TAction.acLixo && !boolHave));
                        if (this.etapa != 4 || deleted) this.dismiss(true, deleted, true);

                        if (success) this.util.toastSimply(success);

                    },
                    erro => {
                        let boxfind = this.getcard(this.meritums[0]);
                        if (boxfind) this.datebkp = boxfind.Certify.CertifyStop;
                        this.util.populateObj(this.copytums[0], this.meritums[0], [], true);
                        this.util.alertResult(erro);
                    }
                );

        };

        let cssClass = (danger ? 'alert-danger' : 'alert-message');
        if (alerta) this.util.alertQuestion(this.copytums[0].MeritumNome, alerta, 'Confirmar', () => onConfir(), false, false, cssClass, onCancel);
        if (!alerta) onConfir();

    }






    /** ************************************************* ARRUMAR ************************************************* **/
    /** *********************************************** etapa-X-Y-Z *********************************************** **/

    produtoNick(produtoTipo: TProdutoTipo = null, textseal: string = 'ProdutoSeals', textcard: string = 'ProdutoCards'): string {

        if (!produtoTipo) produtoTipo = this.produtoTipo;
        return (produtoTipo == TProdutoTipo.ptSeal ? textseal : textcard);

    }

    produtoPega(produtoTipo: TProdutoTipo = null, blended?): any {

        let boxnamed = this.produtoNick(produtoTipo);
        if (blended) return blended[boxnamed].find(bx => !!bx.Certify);

        if (this.etapa == 1) return this.getcard(this.copytums[0], true);//#AKI
        if (this.etapa == 4) return this.getcard(this.copytums[0]);
        if (this.etapa == 4) return this.getcard(this.copytums[0]);
        if (this.etapa == 5) return this.getcard(this.copytums[0], true);//#AKI
        if (this.etapa == 6) return this.getcard(this.copytums[0]);
        if (this.etapa == 7) return this.copytums[0].BlendedArray[this.indexBL][boxnamed].find(bx => !!bx.Certify);
        if (this.etapa == 8) return this.copytums[0].BlendedArray[this.indexBL][boxnamed].find(bx => !!bx.Certify);
        if (this.etapa == 15) return this.copytums[0].BlendedArray[this.indexBL][boxnamed].find(bx => !!bx.Certify);
        if (this.etapa == 20) return this.copytums[0].BlendedArray[this.indexBL][boxnamed][this.indexBX];
        if (this.etapa == 30) return this.copytums[0].BlendedArray[this.indexBL][boxnamed][0];
        if (this.etapa == 300) return this.copytums[0].BlendedArray[this.indexBL].ProdutoSeals[0];

    }







    dismiss(force: boolean = false, deleted: boolean = false, updated: boolean = false) {

        if (!force && this.etapa != this.etape) {
            this.etapa = this.etape;
            this.ngZone.run(() => []); //#GAMBI - etapa 8 e 20, quando troca no click seal para info e volta nao troca a tela na segunda vez depois da requisicao
            this.statusbar(false);
            return;
        }

        if (this.viewCtrl.isOverlay) this.viewCtrl.dismiss({deleted: deleted, updated: updated});
        if (!this.viewCtrl.isOverlay) this.navCtrl.pop();
        this.util.statusBarColor(TStatusBar.sbBackupRestore);

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/meritum-menu/meritum-menu.ts